/* eslint-disable sonarjs/cognitive-complexity */
// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState, useEffect } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import { isCanada } from '@tcp/core/src/utils/utils';
import ResetPassword from '@tcp/core/src/components/features/account/ResetPassword';
import ResetPasswordResendEmail from '@tcp/core/src/components/features/account/ResetPassword/molecules/ResetPasswordResendEmail';
import ResetPasswordOption from '@tcp/core/src/components/features/account/ResetPassword/views/ResetPasswordOption.view';
import { routerPush, routerReplace, isClient, getParamFromString } from '@tcp/core/src/utils';
import TextBox from '@tcp/core/src/components/common/atoms/TextBox';
import Button from '@tcp/core/src/components/common/atoms/Button';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import RichText from '@tcp/core/src/components/common/atoms/RichText';
import {
  CUSTOMER_HELP_DIRECT_LINK_TEMPLATE,
  CUSTOMER_HELP_DIRECT_ROUTES,
} from '@tcp/core/src/components/features/account/CustomerHelp/CustomerHelp.constants';
import Notification from '../../../../common/molecules/Notification';
import { getLabelFromCopyOrFromTranslation } from '../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_PASSWORD_LABELS,
  GlobalPasswordsLabels,
} from '../../../../../utils/labels/globalPassword.labels';
import {
  GLOBAL_LOGIN_LABELS,
  GlobalLoginLabels,
  lblLoginCreateAcctHelp,
} from '../../../../../utils/labels/globalLogin.labels';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblCreateAccount,
} from '../../../../../utils/labels/globalActions.labels';
import {
  GLOBAL_GENERIC_LABELS,
  GlobalGenericLabels,
  lblEmailAddress,
} from '../../../../../utils/labels/globalGeneric.labels';

// eslint-disable-next-line complexity
const ForgotPasswordFullPageView = ({
  className,
  showNotification,
  successFullResetEmail,
  handleSubmit,
  onFormSubmit,
  forgotPasswordErrorMessage,
  isFormSubmitting,
  email,
  openOverlay,
  fullPageAuthEnabled,
  isResetViaText,
  setPassResetOption,
  selectedPassResetOption,
  isShowPhoneOption,
  isShowOTPScreen,
  toggleIsShowOtpScreen,
  triggerPassResetApi,
  maskedPhoneNumber,
  isAccountNotFoundError,
  resetPasswordAction,
  onSubmit,
  initialValues,
  variation,
  resetSendOTPError,
  phoneCountryCode,
}) => {
  const [showSmsTerm, setShowSmsTerm] = useState(false);
  const [loginInprogress, setLoginInProgress] = useState(false);

  const callbackPostResetPassLogin = (isResetFromCheckout) => {
    const successtarget = getParamFromString('successtarget') || '';
    if (isResetFromCheckout) {
      routerPush('/checkout?&redirectFromReset=true', '/checkout?redirectFromReset=true');
    } else if (successtarget) {
      if (
        successtarget.substr(-5) === '/home' || // if '/home' presents at last in 'successtarget', expected values could be ('/home', '/us/home', '/ca/home')
        successtarget.indexOf('confirmation') !== -1 ||
        successtarget.indexOf('register') !== -1
      ) {
        routerPush('/', '/home');
      } else if (
        successtarget.indexOf(CUSTOMER_HELP_DIRECT_LINK_TEMPLATE.MERGE_MYPLACE_ACCOUNTS) !== -1
      ) {
        routerReplace(
          CUSTOMER_HELP_DIRECT_ROUTES.MERGE_MYPLACE_ACCOUNTS.to,
          CUSTOMER_HELP_DIRECT_ROUTES.MERGE_MYPLACE_ACCOUNTS.asPath
        );
      } else {
        routerPush('/', '/home');
      }
    } else {
      routerPush('/', '/home');
    }
  };
  const backToLogin = (confirmPassword) => {
    setLoginInProgress(true);
    const isResetFromCheckout = isClient() && window?.location?.href?.includes('fromPage=checkout');
    const afterLoginHandler = isResetFromCheckout
      ? () => {
          callbackPostResetPassLogin(isResetFromCheckout);
        }
      : undefined;

    onSubmit({
      ...initialValues,
      password: confirmPassword,
      emailAddress: email,
      isResetFromCheckout,
      afterLoginHandler,
    });

    if (!isResetFromCheckout) {
      callbackPostResetPassLogin(isResetFromCheckout);
    }
  };

  const showCreateAccountForm = () => {
    if (fullPageAuthEnabled) {
      routerPush('/home?target=register&successtarget=referrer', '/home/register');
    } else {
      openOverlay({
        component: 'createAccount',
        variation: 'primary',
      });
    }
  };

  const resendViaEmail = () => {
    setShowSmsTerm(true);
    setPassResetOption('email');
    resetPasswordAction({
      logonIdResend: email.toUpperCase().trim(),
      target: 'email',
      logonId: email,
    });
  };
  useEffect(() => {
    if (isAccountNotFoundError) {
      resetSendOTPError(false);
    }
    if (!isResetViaText && email) {
      resendViaEmail();
    }
  }, []);

  const getCreateAccountOptions = (isShowOptions) => {
    return (
      isShowOptions && (
        <>
          <BodyCopy component="div" className="border elem-pt-MED elem-pb-LRG">
            <BodyCopy fontFamily="secondary" fontSize="fs12" textAlign="center">
              {getLabelFromCopyOrFromTranslation(
                `${GLOBAL_LOGIN_LABELS}.${lblLoginCreateAcctHelp}`,
                GlobalLoginLabels
              )}
            </BodyCopy>
          </BodyCopy>
          <Button
            className="create-acc-cta"
            fill="WHITE"
            type="submit"
            buttonVariation="fixed-width"
            data-locator=""
            onClick={showCreateAccountForm}
          >
            {getLabelFromCopyOrFromTranslation(
              `${GLOBAL_ACTIONS_LABELS}.${lblCreateAccount}`,
              GlobalActionsLabels
            )}
          </Button>
        </>
      )
    );
  };
  const showEmailScreen = () => {
    if (isAccountNotFoundError && !successFullResetEmail) {
      return true;
    }
    return !(email && successFullResetEmail) && !maskedPhoneNumber;
  };

  const showCreateAccountCTA = variation !== 'checkout';

  const {
    lbl_forgotPassword_userNotAvailable: lblUserNotAvailable,
    lbl_forgotPassword_content1: lblForgotPwdContent1,
    lbl_forgotPassword_page_secondary_header: lblForgotPwdSecHeader,
    lbl_forgotPassword_page_next_btn: lblForgotPwdNextBtn,
    lbl_dont_have_phone: lblDontHavePhone,
    lbl_send_code_via_email_address: lblSendCodeViaEmail,
  } = getLabelFromCopyOrFromTranslation(GLOBAL_PASSWORD_LABELS, GlobalPasswordsLabels);

  return (
    <>
      <div className={className}>
        {showEmailScreen() && (
          <form
            onSubmit={handleSubmit(onFormSubmit)}
            className={`${className} forgot-password-form`}
          >
            {showNotification && forgotPasswordErrorMessage && (
              <Notification
                isError
                status="error"
                colSize={{ large: 11, medium: 7, small: 6 }}
                message={
                  <RichText className="richTextColor" richTextHtml={forgotPasswordErrorMessage} />
                }
              />
            )}
            {isAccountNotFoundError && isResetViaText && (
              <Notification
                isError
                status="error"
                colSize={{ large: 11, medium: 7, small: 6 }}
                message={lblUserNotAvailable}
              />
            )}

            {!successFullResetEmail && (
              <React.Fragment>
                <BodyCopy
                  textAlign="center"
                  fontFamily="secondary"
                  fontSize="fs28"
                  fontWeight="extrabold"
                  color="TEXT.DARK"
                  className="primary-header-text"
                >
                  <span className="forgot-password-text">{lblForgotPwdContent1}</span>
                </BodyCopy>
                <BodyCopy
                  fontWeight="bold"
                  fontFamily="secondary"
                  textAlign="center"
                  className="elem-mb-XS_1 secondary-header-text"
                  fontSize="fs12"
                  color="TEXT.DARKERGRAY"
                >
                  {lblForgotPwdSecHeader}
                </BodyCopy>
                <BodyCopy
                  component="div"
                  className="border-forgotPassword elem-pt-MED elem-pb-LRG elem-mb-XXXL"
                />
                <BodyCopy component="div" className="elem-mb-LRG">
                  <Field
                    name="Email"
                    placeholder={getLabelFromCopyOrFromTranslation(
                      `${GLOBAL_GENERIC_LABELS}.${lblEmailAddress}`,
                      GlobalGenericLabels
                    )}
                    id="Email"
                    type="text"
                    component={TextBox}
                    value={email}
                    spc
                  />
                </BodyCopy>
                <Button
                  fill="BLUE"
                  disabled={isFormSubmitting}
                  type="submit"
                  buttonVariation="fixed-width"
                  className="rounded-corner"
                >
                  {lblForgotPwdNextBtn}
                </Button>
              </React.Fragment>
            )}
          </form>
        )}

        {showCreateAccountCTA &&
          showEmailScreen() &&
          getCreateAccountOptions(!successFullResetEmail)}

        {successFullResetEmail &&
          (!isResetViaText || isShowOTPScreen) &&
          (email || maskedPhoneNumber) && (
            <ResetPassword
              fullPageView
              email={email}
              backToLoginAction={backToLogin}
              isResetViaText={isResetViaText}
              selectedPassResetOption={selectedPassResetOption}
              maskedPhoneNumber={maskedPhoneNumber}
              toggleIsShowOtpScreen={toggleIsShowOtpScreen}
              setPassResetOption={setPassResetOption}
              loginInprogress={loginInprogress}
            />
          )}
        {isResetViaText && !isShowOTPScreen && email && maskedPhoneNumber && (
          <>
            <ResetPasswordOption
              isResetViaText={isResetViaText}
              setPassResetOption={setPassResetOption}
              selectedPassResetOption={selectedPassResetOption}
              isShowPhoneOption={isShowPhoneOption}
              isShowOTPScreen={isShowOTPScreen}
              toggleIsShowOtpScreen={toggleIsShowOtpScreen}
              triggerPassResetApi={triggerPassResetApi}
              email={email}
              maskedPhoneNumber={maskedPhoneNumber}
              isFormSubmitting={isFormSubmitting}
              showSmsTerm={showSmsTerm}
              resendEmail={resendViaEmail}
              phoneCountryCode={phoneCountryCode}
            />
            <div className="create-account-options-wrapper">
              {isResetViaText && !isCanada() && (
                <div className="send-via-email elem-mt-LRG elem-mb-LRG hide-on-desktop hide-on-tablet">
                  <ResetPasswordResendEmail
                    resendEmail={resendViaEmail}
                    lblCodeNotReceived={lblDontHavePhone}
                    lblResentCode={lblSendCodeViaEmail}
                    isSmsSelected={false}
                    isResetViaText={isResetViaText}
                  />
                </div>
              )}
              {showCreateAccountCTA && getCreateAccountOptions(isResetViaText)}
            </div>
          </>
        )}
      </div>
    </>
  );
};

ForgotPasswordFullPageView.propTypes = {
  className: PropTypes.string.isRequired,
  pristine: PropTypes.bool.isRequired,
  SubmitForgot: PropTypes.shape({}).isRequired,
  showNotification: PropTypes.func.isRequired,
  successFullResetEmail: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isFormSubmitting: PropTypes.bool.isRequired,
  email: PropTypes.string.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
  forgotPasswordErrorMessage: PropTypes.string.isRequired,
  openOverlay: PropTypes.func.isRequired,
  fullPageAuthEnabled: PropTypes.bool.isRequired,
};

export default ForgotPasswordFullPageView;
